// Base stylesheet needed for every page
import './scss/app.scss';
import './scripts/_slider';
import './scripts/instant-page';
import './scripts/filters';
import './scripts/header';
import './scripts/footer';
import './scripts/productimages';
import './scripts/site-overlay';

import '../node_modules/bootstrap/js/dist/collapse';
import '../node_modules/pinch-zoom-js/dist/pinch-zoom.min';

require('./scripts/breadcrumbs');
require('./scripts/cart');
require('./scripts/countdown');
require('./scripts/search');
require('./scripts/predictive-search');
require('./scripts/navigation');
require('./scripts/productblock');
require('./scripts/product');
require('./scripts/productMarkup');
require('./scripts/bundle');
require('./scripts/gallery');
require('./scripts/productPopup');
require('./scripts/productRelated');
require('./scripts/microcart');
require('./scripts/quantity');
require('./scripts/reviews-slider');
require('./scripts/ugc-slider');
require('./scripts/product-slider');
require('./scripts/product-recommendations');
require('./scripts/wishlist');
require('./scripts/customer');
require('./scripts/language');
// require('./scripts/cookiebar');
require('./scripts/bis');
require('./scripts/newsletter');
require('./scripts/readmore');
require('./scripts/recently-viewed');
require('./scripts/slider');
require('./scripts/topbar-usps');